module.exports = __webpack_public_path__ + "static/img/SANXIANG.6aa8ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg/SANXIANG.png
// module id = dHvS
// module chunks = 70